const ASPECT_RATIO = 16 / 9;

function getStageWidthByAspectRatio(
  pageHeight,
  otherElementsButStageHeightAndSourceList,
  sourceListHeight
) {
  const stageHeight =
    pageHeight - (otherElementsButStageHeightAndSourceList + sourceListHeight);
  return stageHeight * ASPECT_RATIO;
}

export default getStageWidthByAspectRatio;
